import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

const transformData = [
    {
        name: 'Serving marginalised communities with my product/service',
        value: 'Item 1'
    },
    {
        name: 'Employing vulnerable and marginalized people in my business',
        value: 'Item 2'
    },
];

/**
 * question: Which of the two is your main business purpose?
 * == baseline
 * question12
 * 
 * @param props 
 * @returns 
 */
export const mainSocialImpactPurposesChartCalculation = (props: any) => {
    return getDefaultPieFormatting(
        'Main social impact purpose',
        transformData.map(({name, value}) => ({
            name,
            y: props.baselineSubmissions.filter((submission: any) => submission.question12 === value).length
        }))
    ) as  Highcharts.Options;
}